/**
 * Submenu content component.
 *
 * Styled container for submenu items with viewport detection.
 */

import type { CSSProperties, ReactNode } from "react";
import * as stylex from "@stylexjs/stylex";
import * as BloomMenu from "bloom-menu";

import { useViewportAware } from "./menu-context";
import { styles } from "./menu-styles.stylex";

export interface MenuSubMenuContentProps {
  children: ReactNode;
  style?: CSSProperties;
}

export function MenuSubMenuContent({
  children,
  style,
}: MenuSubMenuContentProps) {
  const context = useViewportAware();

  return (
    <BloomMenu.SubMenuContent
      style={{
        backgroundColor: "var(--primaris-card)",
        border: "1px solid var(--primaris-border)",
        borderRadius: 12,
        boxShadow:
          "0 8px 24px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06)",
        ...stylex.props(styles.subMenuContent).style,
        ...style,
      }}
    >
      <div
        ref={context?.registerSubMenu}
        {...stylex.props(styles.subMenuContentInner)}
      >
        {children}
      </div>
    </BloomMenu.SubMenuContent>
  );
}
